export const DATE_FORMAT = 'MMM DD, YYYY'
export const DATE_FORMAT_SHORT = 'MMM DD'
export const DATE_FORMAT_LONG = 'MMMM DD YYYY'
export const DATE_FORMAT_BASE = 'MM/DD/YYYY'
export const DATE_FORMAT_SYSTEM = 'YYYY-MM-DD'
export const TIME_FORMAT_BASE = 'hh:mm A'
export const DATE_TIME_FORMAT_BASE = `${DATE_FORMAT_BASE} ${TIME_FORMAT_BASE}`
